import { appStatuses } from "mappers";

export const getUnderwritingAppLink = (status, id) => {
	if (status === appStatuses.UNDERWRITING_IN_PROGRESS) {
		return `/underwriting/in-review/${id}/merchant-info`;
	} else if (status === appStatuses.UNDERWRITING_UNASSIGNED) {
		return `/underwriting/unassigned/${id}/merchant-info`;
	} else {
		return `/underwriting/historical/${id}/merchant-info`;
	}
};

export const getTidEquipmentAppLink = (status, id) => {
	if (status === appStatuses.EQUIPMENT_IN_PROGRESS) {
		return `/tid-request-equipment-queue/in-progress/${id}/details`;
	} else if (status === appStatuses.EQUIPMENT_UNASSIGNED) {
		return `/tid-request-equipment-queue/unassigned/${id}/details`;
	} else {
		return `/tid-request-equipment-queue/pended/${id}/details`;
	}
};

export const getInstallationAppLink = (status, id) => {
	if (status === appStatuses.INSTALLATION_IN_PROGRESS) {
		return `/installation-queue/in-progress/${id}/details`;
	} else if (status === appStatuses.INSTALLATION_UNASSIGNED) {
		return `/installation-queue/unassigned/${id}/details`;
	} else {
		return `/installation-queue/pended/${id}/details`;
	}
};

export const getBoardingAppLink = (status, id, pended = false) => {
	if (pended) {
		return `/boarding-queue/pended/${id}/details`;
	} else if (status === appStatuses.BOARDING_IN_PROGRESS && !pended) {
		return `/boarding-queue/in-progress/${id}/details`;
	} else if (status === appStatuses.BOARDING_UNASSIGNED && !pended) {
		return `/boarding-queue/unassigned/${id}/details`;
	} else {
		return "";
	}
};
